var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[_c('h3',[_vm._t("header")],2),_c('v-content',[_vm._t("content")],2),_c('v-footer',[_vm._v("=======just footer======")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }